import { ArrowNarrowDownIcon } from "@/components/Icons/ArrowNarrowDownIcon";
import { ArrowNarrowRightIcon } from "@/components/Icons/ArrowNarrowRightIcon";
import { ArrowUpIcon } from "@/components/Icons/ArrowUpIcon";
import { Badge } from "@/design-system/Badge";
import { useTranslation } from "@/translations";

type FahWidgetScoreReferenceBadgeProps = {
  currValue: number;
  referenceValue: number;
};
export const FahWidgetScoreReferenceBadge = ({
  currValue,
  referenceValue,
}: FahWidgetScoreReferenceBadgeProps): React.ReactNode => {
  const { t } = useTranslation();
  if (!currValue && !referenceValue) {
    return (
      <Badge icon={<ArrowNarrowRightIcon />} variant="info" size="lg">
        {t("common.label.not-applicable")}
      </Badge>
    );
  }
  const difference = currValue - referenceValue;
  let label = t("component.analytics-widget.fah.label.neutral");
  let icon = <ArrowNarrowRightIcon />;
  let variant: "success" | "warning" | "info" = "info";
  if (difference > 0) {
    icon = <ArrowUpIcon />;
    variant = "success";
    label = t("component.analytics-widget.fah.label.increased", {
      difference: difference.toFixed(1),
    });
  } else if (difference < 0) {
    icon = <ArrowNarrowDownIcon />;
    variant = "warning";
    label = t("component.analytics-widget.fah.label.decreased", {
      difference: difference.toFixed(1),
    });
  }

  return (
    <Badge size="lg" icon={icon} variant={variant}>
      {label}
    </Badge>
  );
};
